<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()"><ion-icon slot="start" name="close"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title class="ion-text-center">Passwort Ändern</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
<form id="accountForm" [formGroup]="passwordChangeForm" (ngSubmit)="onChangePassword()" novalidate>
  <ion-list>
    <ion-item>
      <ion-input label="Aktuelles Passwort" labelPlacement="stacked" type="password" autofocus="true" autocomplete="password" inputmode="password" name="current_password" formControlName="current_password"></ion-input>
    </ion-item>
    <ion-item>
      <ion-input label="Neues Passwort" labelPlacement="stacked" type="password" autocomplete="password" name="password" formControlName="password"></ion-input>
    </ion-item>
    <ion-item>
      <ion-input label="Neues Passwort wiederholen" labelPlacement="stacked" type="password" autocomplete="password" name="password2" formControlName="password2"></ion-input>
    </ion-item>
  </ion-list>
  <ion-button type="submit" size="block" [disabled]="!passwordChangeForm.dirty || passwordChangeForm.invalid">Passwort ändern</ion-button>
</form>

</ion-content>
